module.exports = __webpack_public_path__ + "img/Weapon_236.f167b0ee.png";